import React, { FC, useState } from 'react';
import Image from 'next/image';
import styles from './ClientMultiLogo.module.scss';
import classNames from 'classnames';
// Import lib files
import { ClientMultiLogoProp } from '@/libs/interfaceProps/clientMultiLogoProps';
import currentDateTimeStamp from '@/libs/currentDateTimestamp/currentDateTimestamp';
import { orgBannerProps } from '@/libs/interfaceProps/orgBannerProps';
import { useOrgContext } from '@/context/orgContext';
const ClientMultiLogo: FC<ClientMultiLogoProp> = ({
  width,
  height,
  page,
  setbreakClass
}) => {
  //  The states to use show the image (By default the element will hidden).
  //  If the given src is valid then show the element.
  const [showSquareLogo2, setShowSquareLogo2] = useState(false);
  const [showSquareLogo3, setShowSquareLogo3] = useState(false);
  const [showSquareLogo4, setShowSquareLogo4] = useState(false);
  const {
    orgData
  } = useOrgContext();
  const {
    images
  }: orgBannerProps = orgData;
  if (setbreakClass) {
    if (showSquareLogo2 || showSquareLogo3 || showSquareLogo4) {
      setbreakClass('titleLineBreak');
    } else {
      setbreakClass('');
    }
  }
  return <div className={classNames(styles['the-client'], styles[page], showSquareLogo2 && showSquareLogo3 && showSquareLogo4 ? styles['brand-logosx3'] : styles['brand-logos<3'], [showSquareLogo2, showSquareLogo3, showSquareLogo4].includes(true) ? styles['multiple-brand-logos'] : styles['single-client-logo'])} data-sentry-component="ClientMultiLogo" data-sentry-source-file="ClientMultiLogo.tsx">
   <div className={classNames(styles['secondary-client-logos-block'], 'd-none')} data-bdd={'Additional-client-logos'}>
    {images?.logo2 && <div className={classNames(styles['company-logo'], styles[`clientLogos-2`], styles['secondary-client-logos'], showSquareLogo2 ? 'd-flex' : 'd-none') + ' image-wrapper'} data-bdd={'client-logo-2'} key={`org-xtra-logo2`}>
      <Image data-bdd={'bdd-client-logo'} src={`${images?.logo2}?t=${currentDateTimeStamp()}`} alt={'client-logo'} priority={true} width={width} height={height} unoptimized={true} onLoad={() => {
          setShowSquareLogo2(true);
        }} />
     </div>}
    {images?.logo3 && <div className={classNames(styles['company-logo'], styles[`clientLogos-3`], styles['secondary-client-logos'], showSquareLogo3 ? 'd-flex' : 'd-none') + ' image-wrapper'} data-bdd={'client-logo-3'} key={`org-xtra-logo4`}>
      <Image data-bdd={'bdd-client-logo'} src={`${images?.logo3}?t=${currentDateTimeStamp()}`} alt={'client-logo'} priority={true} width={width} height={height} unoptimized={true} onLoad={() => {
          setShowSquareLogo3(true);
        }} />
     </div>}
    {images?.logo4 && <div className={classNames(styles['company-logo'], styles[`clientLogos-4`], styles['secondary-client-logos'], showSquareLogo4 ? 'd-flex' : 'd-none') + ' image-wrapper'} data-bdd={'client-logo-4'} key={`org-xtra-logo`}>
      <Image data-bdd={'bdd-client-logo'} src={`${images?.logo4}?t=${currentDateTimeStamp()}`} alt={'client-logo'} priority={true} width={width} height={height} unoptimized={true} onLoad={() => {
          setShowSquareLogo4(true);
        }} />
     </div>}
   </div>
  </div>;
};
export default ClientMultiLogo;